(ns humbleai.belt.malli.type.domain
  (:refer-clojure :exclude [type])
  (:require
   [clojure.string :as str]
   [clojure.test.check.generators :as gen]
   [malli.generator :as mg]
   [malli.core :as malli]))

(def domain-regex #"(?:(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?|\[(?:(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9]))\.){3}(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9])|[a-zA-Z0-9-]*[a-zA-Z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])")

(defn domain?
  [s]
  (re-matches domain-regex s))

(def type
  {:domain (malli/-simple-schema
           {:type :domain
            :pred domain?})})

(def alphanumeric-str-gen-min3-max5
  (->> (gen/vector gen/char-alphanumeric 3 5)
       (gen/fmap str/join)))

(def domain-gen
  (gen/fmap
   (partial str/join \.)
   (gen/vector alphanumeric-str-gen-min3-max5 2)))

(defmethod mg/-schema-generator :domain [_ _] domain-gen)

(defn ->domain
  [s]
  (first (re-find domain-regex s)))

(def transformer
  {:name :domain-transfomer
   :decoders {:domain ->domain}})
